/**
 * Get IANA time zone identifier (ex. "America/New_York"), if available.
 * If not available, returns null.
 */
export function getTimeZone() {
    let tz = "";
    try {
        tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (warning) {
        console.warn("could not pull IANA time zone", warning);
    }

    return tz ? tz : null;
}

/**
 * Get current local offset from UTC, in minutes, using getTimezoneOffset.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset
 */
export function getUtcOffset() {
    const date = new Date();
    const offset = date.getTimezoneOffset();
    return offset;
}

/**
 * Get Vyne-defined time zone headers bearing information about the requesting client's time zone.
 * Facilitates server-side report formatting of dates/times.
 * See ProviderController.PaymentReport for details.
 */
export function getTimeZoneHeaders() {
    const headers: Record<string, string> = {};
    // grab header strings
    const [tz, offset] = [getTimeZone(), getUtcOffset().toString()];
    if (tz) headers["Time-Zone"] = tz;
    headers["Time-Zone-Current-Offset"] = offset;
    return Object.freeze(headers);
}
